module.exports = __webpack_public_path__ + "manual-draggable.png?d5c26672776458f71b029b2c8adfd7bf";


//////////////////
// WEBPACK FOOTER
// ./src/images/manual-draggable.png
// module id = 404
// module chunks = 0